import React, { useContext } from "react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import { AppContext } from "../../context/app.context";
import { ScheduleContext } from "../../context/schedule.context";
import { ModelCxContext } from "../../context/modelCx.context";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// #174 — "add to a locked day" confirmation.
//
// When a user drops a job/repair onto a LOCKED installer-day cell,
// schedule.context's useEffect[dropObject] intercepts the drop and opens this
// modal (instead of scheduling). It names who locked the day and asks whether
// to add anyway.
//
//   • Add anyway → unlock the day (tsToggleCellLock(..., false), which the
//     EventLog records against the force-adder — Brandon's "lock log user last
//     name, first initial"), then proceed to JobInitModal so the job schedules
//     onto the now-unlocked cell. Per Brandon's spec, the day must be
//     re-locked afterward if still desired.
//   • Cancel → abandon the drag (clear drag/drop state); the day stays locked.
//
// Mirrors RepairOrderConfirmModal's intercept-and-resume pattern.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

function LockConfirmModal({ setOpenLockConfirmModal }) {
  const { openLockConfirmModal, setOpenJobInitModal } = useContext(AppContext);
  const { tsToggleCellLock } = useContext(ModelCxContext);
  const { setDragObject, setDropObject } = useContext(ScheduleContext);

  const payrollNo = openLockConfirmModal?.payrollNo || "";
  const date = openLockConfirmModal?.date || "";
  const lockedBy = openLockConfirmModal?.lockedBy || "";

  // - - - - - - - - - -

  const onAddAnyway = () => {
    // Unlock the day (logs the force-adder via the EventLog) then continue
    // into the normal scheduling flow — the drag/drop state is still set, so
    // JobInitModal picks up exactly what was dropped where.
    tsToggleCellLock(date, payrollNo, false);
    setOpenLockConfirmModal({ show: false });
    setOpenJobInitModal({ show: true });
  };

  const onCancel = () => {
    setDragObject("");
    setDropObject({ id: "" });
    setOpenLockConfirmModal({ show: false });
  };

  // - - - - - - - - - -

  return (
    <Modal onClose={onCancel} disableCloseOnClickOutSide>
      <Modal.Header>Day Locked</Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-3 max-w-md">
          <div>
            This day was locked by{" "}
            <span className="font-bold">{lockedBy || "another user"}</span>. Add
            to it anyway?
          </div>
          <div className="text-xs opacity-70">
            Adding will <span className="font-bold">unlock</span> the day. If you
            still want it locked, lock it again afterward.
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <div className="h-8 flex flex-wrap gap-3 justify-center">
          <Button className="uppercase" onClick={onAddAnyway}>
            Add anyway
          </Button>
          <Button color="light" className="uppercase" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default LockConfirmModal;
